import React, { useEffect, useState, memo, createElement } from 'react';
import { ChevronDown, Check, ShieldCheck, Lock, CreditCard, HelpCircle, AlertTriangle, BookOpen, Heart, Users, Gift } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { CTAButton } from './components/CTAButton';
import { TestimonialCard } from './components/TestimonialCard';
const PAYMENT_URL = 'https://pay.hotmart.com/W103408326L?off=smrxzfw3&checkoutMode=10&src=Pack100citas_conjunto_6';
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1756158608423228');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1756158608423228&ev=PageView&noscript=1" />';
    document.body.appendChild(noscript);
  }, []);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: '¿Es material digital?',
    a: 'Sí, se entrega en PDF y llega al instante.'
  }, {
    q: '¿Funciona para cualquier edad?',
    a: 'Sí, las actividades se adaptan a cada familia.'
  }, {
    q: '¿Se puede imprimir?',
    a: 'Sí, perfectamente.'
  }, {
    q: '¿Sirve aunque tengamos poco tiempo?',
    a: 'Justamente está pensado para eso.'
  }];
  const bonuses = [{
    title: 'Bono #1 – Adios al aburrimiento 52 planes mágicos y economicos',
    desc: 'Ideas listas para todo el año, sin pensar.',
    img: 'https://cdn.magicpatterns.com/uploads/2R4xT7m85n4thrbxN8Vkxn/BONO_2.png'
  }, {
    title: 'Bono #2 – Juegos para-Descubrir lo que Tu Hija Realmente Piensa y Siente',
    desc: 'Dinámicas para conocerse mejor y abrir conversaciones reales.',
    img: 'https://cdn.magicpatterns.com/uploads/vd6PYYow3c9ZtvWdGcWJS1/BONO_1.png'
  }, {
    title: 'Bono #3 – 30 cosas que quiero que mi hija nunca olvide aunque yo no este',
    desc: 'Frases y mensajes para guardar para siempre.',
    img: 'https://cdn.magicpatterns.com/uploads/wJDf6dAfCTYYDQfEzH9uWq/BONO_3.png'
  }, {
    title: 'Bono #4 – Abuelita, cuéntame tu historia',
    desc: 'Un hermoso libro para que tu abuela comparta sus recuerdos, anécdotas y enseñanzas de vida.',
    img: 'https://cdn.magicpatterns.com/uploads/akhJP4pXk6V5aVW2aFHBEd/BONO_4.png'
  }, {
    title: 'Bono #5 – Abuelito, cuéntame tu historia',
    desc: 'Un espacio para que el abuelo cuente sus vivencias, sabiduría y recuerdos que quedarán para siempre.',
    img: 'https://cdn.magicpatterns.com/uploads/3FpY5CTan4q6KXEDKXNSMa/BONO_5.png'
  }, {
    title: 'Bono #6 – Mamá, cuéntame tu historia',
    desc: 'Un recuerdo invaluable donde mamá puede dejar plasmadas sus experiencias, consejos y momentos más especiales.',
    img: 'https://cdn.magicpatterns.com/uploads/92HR4yVGGmq5KmZQpwtpGN/BONO_6.png'
  }, {
    title: 'Bono #7 – Papá, cuéntame tu historia',
    desc: 'Un libro para que papá comparta sus recuerdos, enseñanzas y los momentos que marcaron su vida.',
    img: 'https://cdn.magicpatterns.com/uploads/bkZRYgYEwHZbMbGTMPbGrC/BONO_7.png'
  }];
  return <div className="font-sans text-gray-900 bg-white pt-12" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <PurchaseNotification data-id="element-2" />

      {/* HERO */}
      <header className="bg-white pb-12 pt-8 px-4 text-center border-b border-gray-200" data-id="element-3">
        <div className="max-w-4xl mx-auto" data-id="element-4">
          <h1 className="text-4xl md:text-6xl font-black mb-6 leading-tight tracking-tight" data-id="element-5">
            <span className="text-red-600" data-id="element-6">❤️ Pack 100 Citas</span>
            <br data-id="element-7" />
            <span className="text-3xl md:text-5xl font-bold text-gray-800 mt-2 block" data-id="element-8">
              Mamá • Papá • Hijos
            </span>
          </h1>

          <div className="my-8 flex justify-center" data-id="element-9">
            <img src="https://cdn.magicpatterns.com/uploads/q68Va7f1235i4y2MMkjDDD/MOCAP_100_CITAS.png" alt="Pack 100 Citas Completo" className="w-full max-w-2xl drop-shadow-2xl" data-id="element-10" />
          </div>

          <div className="bg-yellow-100 border-l-8 border-yellow-400 p-6 mb-8 text-left max-w-3xl mx-auto rounded-r-lg shadow-sm" data-id="element-11">
            <p className="text-xl md:text-2xl font-bold text-gray-800 mb-2" data-id="element-12">
              Momentos reales. Conexión verdadera. Recuerdos que quedan para
              siempre.
            </p>
            <p className="text-lg text-gray-700" data-id="element-13">
              Tiempo de calidad listo para usar, sin pantallas y sin tener que
              pensar qué hacer.
            </p>
          </div>

          <a href={PAYMENT_URL} target="_blank" rel="noopener noreferrer" className="group relative inline-flex flex-col items-center justify-center w-full md:w-auto min-w-[300px] bg-green-500 hover:bg-green-600 text-white font-black py-4 px-8 rounded-lg shadow-[0_6px_0_0_rgb(21,128,61)] hover:shadow-[0_3px_0_0_rgb(21,128,61)] hover:translate-y-[3px] transition-all duration-150 transform text-center uppercase tracking-wide" data-id="element-14">
            <span className="flex items-center gap-2 text-xl md:text-2xl drop-shadow-md" data-id="element-15">
              👉 SÍ, QUIERO ACCEDER AHORA
            </span>
            <span className="text-xs md:text-sm font-normal normal-case opacity-90 mt-1" data-id="element-16">
              Descarga Digital Inmediata
            </span>
          </a>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-600 font-medium" data-id="element-17">
            <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-18" />
            Garantía de satisfacción de 7 días
          </div>
        </div>
      </header>

      {/* HOOK / PROBLEM */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-19">
        <div className="max-w-3xl mx-auto" data-id="element-20">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-21">
            Si sos mamá o papá, dejame hacerte una pregunta honesta
          </h2>
          <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100" data-id="element-22">
            <p className="text-xl md:text-2xl font-bold text-center mb-6" data-id="element-23">
              ¿Sentís que el tiempo pasa… <br data-id="element-24" />
              <span className="bg-yellow-200 px-2" data-id="element-25">
                pero los momentos importantes se te escapan?
              </span>
            </p>
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed" data-id="element-26">
              <p data-id="element-27">No porque no ames a tu familia.</p>
              <p data-id="element-28">No porque no quieras estar.</p>
              <p className="font-semibold" data-id="element-29">
                Sino porque la rutina, el cansancio y las pantallas lo ocupan
                todo.
              </p>
              <p data-id="element-30">
                Y cuando te das cuenta…{' '}
                <span className="font-bold text-red-600" data-id="element-31">el día terminó.</span>
              </p>
            </div>
          </div>

          <div className="mt-12" data-id="element-32">
            <h3 className="text-2xl font-black text-center mb-8 uppercase tracking-wide text-gray-800" data-id="element-33">
              El problema que nadie dice en voz alta
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-34">
              {['Compartís tiempo, pero no conexión real', 'Cada uno está con su celular', 'Querés hacer algo especial, pero no sabés qué', 'Los días pasan rápido', 'Los hijos crecen', 'Sentís que te perdés momentos importantes'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm border-l-4 border-red-500" data-id="element-35">
                  <AlertTriangle className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-36" />
                  <span className="font-medium" data-id="element-37">{item}</span>
                </div>)}
            </div>
            <div className="mt-10 text-center bg-gray-800 text-white p-6 rounded-xl shadow-lg" data-id="element-38">
              <p className="text-lg mb-2" data-id="element-39">
                Y aparece ese pensamiento incómodo:
              </p>
              <p className="text-2xl font-bold italic" data-id="element-40">
                "Podría estar haciendo más… si tuviera una forma simple de
                hacerlo."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-16 px-4 bg-white" data-id="element-41">
        <div className="max-w-4xl mx-auto text-center" data-id="element-42">
          <div className="inline-block bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold mb-4 border border-green-200" data-id="element-43">
            ✅ La solución
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-gray-900" data-id="element-44">
            ❤️ Pack 100 Citas
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-45">
            Un sistema simple de momentos guiados, diseñado para ayudarte a
            conectar de verdad con tus hijos.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-46">
            <div className="bg-blue-50 p-8 rounded-2xl border-2 border-blue-100 hover:border-blue-300 transition-colors" data-id="element-47">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md text-3xl" data-id="element-48">
                📖
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-49">Abrís el libro</h3>
              <p className="text-gray-600" data-id="element-50">
                Sin complicaciones ni preparativos eternos.
              </p>
            </div>
            <div className="bg-purple-50 p-8 rounded-2xl border-2 border-purple-100 hover:border-purple-300 transition-colors" data-id="element-51">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md text-3xl" data-id="element-52">
                👆
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-53">Elegís una cita</h3>
              <p className="text-gray-600" data-id="element-54">
                Actividades diseñadas para cada vínculo.
              </p>
            </div>
            <div className="bg-red-50 p-8 rounded-2xl border-2 border-red-100 hover:border-red-300 transition-colors" data-id="element-55">
              <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md text-3xl" data-id="element-56">
                ❤️
              </div>
              <h3 className="font-bold text-xl mb-2" data-id="element-57">Vivís el momento</h3>
              <p className="text-gray-600" data-id="element-58">
                Sin pantallas. Sin planificar. Sin estrés.
              </p>
            </div>
          </div>

          <CTAButton text="QUIERO EL PACK 100 CITAS AHORA" href={PAYMENT_URL} data-id="element-59" />
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-60">
        <div className="max-w-4xl mx-auto" data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-62">
            📚 ¿Qué incluye exactamente el Pack 100 Citas?
          </h2>
          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-63">
            {[{
            title: '100 Citas Mamá e Hija',
            desc: 'Momentos uno a uno para hablar, reír y fortalecer el vínculo.',
            icon: Heart
          }, {
            title: '100 Citas Mamá e Hijo',
            desc: 'Actividades para conectar desde el juego, la escucha y el amor.',
            icon: Users
          }, {
            title: '100 Citas Papá e Hija',
            desc: 'Espacios únicos para reforzar seguridad, confianza y cercanía.',
            icon: ShieldCheck
          }, {
            title: '100 Citas Papá e Hijo',
            desc: 'Propuestas para compartir tiempo real y crear recuerdos juntos.',
            icon: BookOpen
          }].map((item, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-md border-l-4 border-blue-500 flex gap-4" data-id="element-64">
                <div className="bg-blue-100 p-3 rounded-full h-fit" data-id="element-65">
                  <item.icon className="w-6 h-6 text-blue-600" data-id="element-66" />
                </div>
                <div data-id="element-67">
                  <h3 className="font-bold text-lg mb-1" data-id="element-68">✅ {item.title}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-69">{item.desc}</p>
                </div>
              </div>)}
          </div>
          <div className="text-center bg-gray-900 text-white p-6 rounded-xl shadow-xl transform rotate-1 hover:rotate-0 transition-transform" data-id="element-70">
            <p className="text-2xl font-bold" data-id="element-71">
              👉 Un solo Pack. 👉 Todos los vínculos padres e hijos cubiertos.
            </p>
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-72">
        <div className="max-w-5xl mx-auto" data-id="element-73">
          <h2 className="text-3xl font-black text-center mb-12" data-id="element-74">
            🔄 Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-75">
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-76">
              <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-77">
                <span className="text-3xl" data-id="element-78">❌</span> Antes del Pack
              </h3>
              <ul className="space-y-4" data-id="element-79">
                {['Rutina automática', 'Mucho celular', 'Poco diálogo', 'Cansancio emocional', 'Sensación de culpa', '"Después lo hacemos…"'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-80">
                    <div className="w-2 h-2 bg-red-400 rounded-full" data-id="element-81" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-green-50 p-8 rounded-2xl border-2 border-green-200 shadow-lg relative overflow-hidden" data-id="element-82">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-83">
                TU NUEVA VIDA
              </div>
              <h3 className="text-2xl font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-84">
                <span className="text-3xl" data-id="element-85">✅</span> Después del Pack
              </h3>
              <ul className="space-y-4" data-id="element-86">
                {['Momentos reales', 'Risas y charlas', 'Tiempo de calidad', 'Más conexión', 'Tranquilidad emocional', 'Recuerdos que quedan'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium text-gray-800" data-id="element-87">
                    <Check className="w-5 h-5 text-green-600" data-id="element-88" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-89">
        <div className="max-w-5xl mx-auto" data-id="element-90">
          <div className="text-center mb-16" data-id="element-91">
            <span className="bg-yellow-400 text-black font-black px-4 py-1 rounded uppercase tracking-wider text-sm" data-id="element-92">
              Oferta Especial
            </span>
            <h2 className="text-4xl md:text-5xl font-black mt-4 mb-4 text-white" data-id="element-93">
              🎁 REGALOS ESPECIALES
            </h2>
            <p className="text-xl text-gray-300" data-id="element-94">
              BONOS INCLUIDOS HOY (Sin costo adicional)
            </p>
          </div>
          <div className="space-y-12" data-id="element-95">
            {bonuses.map((bonus, index) => <div key={index} className="bg-gray-800 rounded-2xl p-6 md:p-8 border border-gray-700 flex flex-col md:flex-row gap-8 items-center" data-id="element-96">
                {bonus.img ? <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-97">
                    <img src={bonus.img} alt={bonus.title} className="w-full rounded-lg shadow-2xl" data-id="element-98" />
                  </div> : <div className="w-full md:w-1/3 flex-shrink-0 bg-gray-700 h-64 rounded-lg flex items-center justify-center text-gray-500" data-id="element-99">
                    <Gift className="w-16 h-16 opacity-50" data-id="element-100" />
                  </div>}
                <div className="flex-1 text-center md:text-left" data-id="element-101">
                  <div className="inline-block bg-green-600 text-white text-xs font-bold px-2 py-1 rounded mb-3" data-id="element-102">
                    GRATIS HOY
                  </div>
                  <h3 className="text-2xl font-bold text-yellow-400 mb-3" data-id="element-103">
                    {bonus.title}
                  </h3>
                  <p className="text-lg text-gray-300" data-id="element-104">{bonus.desc}</p>
                </div>
              </div>)}
          </div>
          <div className="mt-12 text-center" data-id="element-105">
            <p className="text-2xl font-bold text-white mb-8" data-id="element-106">
              👉 Legado familiar + memoria emocional.
            </p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-16 px-4 bg-white relative overflow-hidden" data-id="element-107">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] opacity-50" data-id="element-108"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-109">
          <div className="bg-white rounded-3xl shadow-2xl border-4 border-yellow-400 overflow-hidden" data-id="element-110">
            <div className="bg-red-600 text-white text-center py-4 px-4 animate-pulse" data-id="element-111">
              <p className="font-bold text-lg uppercase tracking-wider" data-id="element-112">
                ⏰ Oferta por tiempo limitado
              </p>
            </div>
            <div className="p-8 md:p-12 text-center" data-id="element-113">
              <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-2" data-id="element-114">
                Accedé al Pack 100 Citas completo
              </h2>
              <p className="text-gray-500 mb-8 font-medium" data-id="element-115">
                todos los bonos incluidos
              </p>
              <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left max-w-md mx-auto border border-gray-200" data-id="element-116">
                <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-117">
                  <Gift className="w-5 h-5 text-purple-600" data-id="element-118" /> 📦 Lo que vas a
                  recibir hoy:
                </h3>
                <ul className="space-y-3" data-id="element-119">
                  <li className="flex items-start gap-3" data-id="element-120">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-121" />
                    <span className="text-gray-700" data-id="element-122">
                      4 libros principales (mamá e hija, mamá e hijo, papá e
                      hija, papá e hijo)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-123">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-124" />
                    <span className="text-gray-700 font-bold" data-id="element-125">
                      7 bonos emocionales exclusivos
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-126">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-127" />
                    <span className="text-gray-700" data-id="element-128">
                      Actividades listas para usar
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-129">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-130" />
                    <span className="text-gray-700" data-id="element-131">
                      Formato PDF (celular, tablet, PC)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-132">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-133" />
                    <span className="text-gray-700" data-id="element-134">Acceso inmediato</span>
                  </li>
                </ul>
              </div>
              <div className="mb-8" data-id="element-135">
                <p className="text-gray-500 line-through text-xl mb-1" data-id="element-136">
                  Precio regular: USD $25
                </p>
                <div className="flex items-center justify-center gap-2" data-id="element-137">
                  <span className="text-6xl font-black text-green-600 tracking-tighter" data-id="element-138">
                    USD $9,99
                  </span>
                </div>
                <p className="text-red-500 font-bold mt-2 animate-bounce" data-id="element-139">
                  🔥 HOY SOLO
                </p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-140">
                  Pagás en la moneda de tu país
                </p>
              </div>

              <CTAButton text="QUIERO EL PACK 100 CITAS AHORA" className="w-full md:w-full" href={PAYMENT_URL} data-id="element-141" />

              <div className="mt-6 flex justify-center gap-4 opacity-60 grayscale hover:grayscale-0 transition-all" data-id="element-142">
                <CreditCard className="w-8 h-8" data-id="element-143" />
                <Lock className="w-8 h-8" data-id="element-144" />
                <ShieldCheck className="w-8 h-8" data-id="element-145" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-12 px-4 bg-gray-50 border-y border-gray-200" data-id="element-146">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8" data-id="element-147">
          <div className="flex-shrink-0" data-id="element-148">
            <div className="w-32 h-32 bg-yellow-400 rounded-full flex items-center justify-center border-4 border-yellow-200 shadow-lg rotate-12" data-id="element-149">
              <ShieldCheck className="w-16 h-16 text-white" data-id="element-150" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-151">
            <h3 className="text-2xl font-black mb-2" data-id="element-152">🔒 Garantía sin riesgo</h3>
            <p className="text-lg text-gray-700 mb-4" data-id="element-153">
              Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
              del dinero.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-4 font-bold text-gray-900" data-id="element-154">
              <span className="flex items-center gap-1" data-id="element-155">
                <Check className="w-4 h-4 text-green-500" data-id="element-156" /> Sin preguntas.
              </span>
              <span className="flex items-center gap-1" data-id="element-157">
                <Check className="w-4 h-4 text-green-500" data-id="element-158" /> Sin letra chica.
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-white" data-id="element-159">
        <div className="max-w-6xl mx-auto" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-161">
            💬 Lo que dicen otros padres
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-162">
            <TestimonialCard quote="Mi hija espera cada cita con ilusión. Nos acercó muchísimo." author="María" role="mamá de 2 hijos" data-id="element-163" />
            <TestimonialCard quote="Nos devolvió momentos que la rutina nos estaba robando." author="Lucas" role="papá" data-id="element-164" />
            <TestimonialCard quote="Ahora tengo actividades listas para compartir con mis hijos sin pensar." author="Carolina" role="mamá" data-id="element-165" />
            <div className="md:col-span-1" data-id="element-166">
              <TestimonialCard quote="No es un libro. Es tiempo de calidad real." author="Andrea" role="mamá" data-id="element-167" />
            </div>
            <div className="md:col-span-2" data-id="element-168">
              <TestimonialCard quote="Mis hijos ahora me buscan para hacer las citas. Cambió nuestra dinámica familiar completamente." author="Roberto" role="papá de 3" data-id="element-169" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-170">
        <div className="max-w-3xl mx-auto" data-id="element-171">
          <h2 className="text-3xl font-black text-center mb-12 flex items-center justify-center gap-3" data-id="element-172">
            <HelpCircle className="w-8 h-8 text-blue-500" data-id="element-173" /> Preguntas
            frecuentes
          </h2>
          <div className="space-y-4" data-id="element-174">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-175">
                <button onClick={() => toggleFaq(index)} className="w-full flex items-center justify-between p-5 text-left font-bold text-gray-900 hover:bg-gray-50 transition-colors" data-id="element-176">
                  {faq.q}
                  <ChevronDown className={`w-5 h-5 transition-transform ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-177" />
                </button>
                {openFaq === index && <div className="p-5 pt-0 text-gray-600 border-t border-gray-100 bg-gray-50" data-id="element-178">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="py-20 px-4 bg-white text-center" data-id="element-179">
        <div className="max-w-4xl mx-auto" data-id="element-180">
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-181">
            ❤️ La conexión no se posterga
          </h2>
          <p className="text-2xl text-gray-600 mb-12" data-id="element-182">
            No necesitás más tiempo. <br data-id="element-183" />
            <span className="font-bold text-gray-900" data-id="element-184">
              Necesitás mejores momentos.
            </span>
          </p>

          <CTAButton text="Accedé ahora al Pack 100 Citas" href={PAYMENT_URL} data-id="element-185" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center text-sm" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <p className="mb-4" data-id="element-188">© 2026 DescargaTop – Pack 100 Citas</p>
          <p className="mb-8" data-id="element-189">Todos los derechos reservados</p>
          <div className="flex justify-center gap-6" data-id="element-190">
            <a href="#" className="hover:text-white transition-colors" data-id="element-191">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-192">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </footer>
    </div>;
}